"use strict";
// (C) 2019-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.measureName = exports.measureFormat = exports.measureGroupItems = exports.dataViewDimensionItems = exports.dataViewHeaders = void 0;
/**
 * @internal
 */
function dataViewHeaders(dataView, dimIdx) {
    var _a;
    return (_a = dataView.headerItems[dimIdx]) !== null && _a !== void 0 ? _a : [];
}
exports.dataViewHeaders = dataViewHeaders;
/**
 * @internal
 */
function dataViewDimensionItems(dataView, dimIdx) {
    var dimensionDescriptor = dataView.result.dimensions[dimIdx];
    return dimensionDescriptor ? dimensionDescriptor.headers : [];
}
exports.dataViewDimensionItems = dataViewDimensionItems;
/**
 * @internal
 */
function measureGroupItems(measureGroup) {
    return measureGroup.measureGroupHeader.items;
}
exports.measureGroupItems = measureGroupItems;
/**
 * @internal
 */
function measureFormat(measureDescriptor) {
    return measureDescriptor.measureHeaderItem.format;
}
exports.measureFormat = measureFormat;
/**
 * @internal
 */
function measureName(measureDescriptor) {
    return measureDescriptor.measureHeaderItem.name;
}
exports.measureName = measureName;
//# sourceMappingURL=utils.js.map